


































import draggable from 'vuedraggable';
import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import { SchoolGroupStudent } from '@/models/school-group/school-group-student';
import { GroupSetting } from '@/models/school-group/group-setting';
import { StudentGroupingResult } from '@/models/student/student-grouping-result';
import { studentFilterModule } from '@/store/modules/frames/student-filters.module';
import { groupModule } from '@/store/modules/entities/group.module';
import { SchoolGroupStudentSearch } from '@/models/school-group/school-group-student-search';
import GGroupDraggable from '@/components/GGroupDraggable.vue';
import { Student } from '@/models/student/student';

@Component({
  name: 'GClassManagementGroupProposal',
  components: {
    GGroupDraggable,
    draggable,
  },
  computed: {},
  methods: {},
  validations: {},
})
export default class GClassManagementGroupProposal extends mixins(GPageBase) {
  options: any = { group: 'drag_list' };
  nonCategorizedStudents: Student[] = [];
  loading: boolean = false;

  @Watch('nonCategorizedStudents')
  tranferNonCategories(value: any[]) {
    if (this.nonCategorizedStudents === null) {
      this.nonCategorizedStudents = [];
    }
    this.$emit('return', this.nonCategorizedStudents.length === 0);
  }

  async created() {
    groupModule.clean();

    const fetchGroupResultParams = {
      targetType: this.targetType,
      targetID: this.targetID,
      selectedCommaTagIDs: this.selectedCommaTagIDs,
      groupNum: this.groupSetting.numberOfGroups,
      groupType: this.groupSetting.groupType,
      growingPurpose: this.groupSetting.purposeOfTraining,
      schoolCompetencyID: this.groupSetting.schoolCompetencyID,
    } as SchoolGroupStudentSearch;

    this.loading = true;
    await groupModule.fetchStudentGroupingResults(fetchGroupResultParams);
    groupModule.setStudentGroups(this.studentGroupingResultData);
    this.nonCategorizedStudents = this.studentGroupingResultNonCategorizedStudents;
    this.loading = false;
  }

  get groupSetting(): GroupSetting {
    return groupModule.groupSetting;
  }

  get studentGroupingResults(): StudentGroupingResult {
    return groupModule.studentGroupingResults;
  }

  get studentGroupingResultData(): SchoolGroupStudent[] {
    if (this.studentGroupingResults) return this.studentGroupingResults.data;
  }

  get studentGroupingResultNonCategorizedStudents(): Student[] {
    if (this.studentGroupingResults) return this.studentGroupingResults.nonCategorizedStudents;
  }

  get targetType(): number {
    return studentFilterModule.targetType;
  }

  get targetID(): number {
    return studentFilterModule.targetID;
  }

  get selectedCommaTagIDs(): string {
    return studentFilterModule.commaSelectedTagIDs;
  }

  get studentGroups(): SchoolGroupStudent[] {
    return groupModule.studentGroups;
  }

  get isEmptyNonCategorizedStudents(): boolean {
    return this.nonCategorizedStudents == null || this.nonCategorizedStudents.length == 0;
  }

  get hasChildGroupFourMembers(): boolean {
    let hasMembers: boolean = true;
    if (this.studentGroups.length > 0) {
      hasMembers = this.studentGroups.every((group: SchoolGroupStudent) => {
        return group.studentList.length >= 3;
      });
    }
    return hasMembers;
  }

  get preventSubmitGroupingPropsal(): boolean {
    return !this.isEmptyNonCategorizedStudents || !this.hasChildGroupFourMembers;
  }
}
